# import AuthResponseFragment from "../fragments/auth-response.graphql"

mutation loginWithPassword($username: String!, $password: String!) {
  loginWithPassword(username: $username, password: $password) {
    ...AuthResponseFragment
  }
}
